import apiRequestService from '@/commonProject/service/apiRequestService';

export default class SettingRepository {
    /**
     * 契約情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getAgreeApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/stgcon', requestBody, idToken);
        return result;
    }
    /**
     * セキュリティ設定取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getSecurityApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/stgsec', requestBody, idToken);
        return result;
    }
    /**
     * セキュリティ設定更新API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getSecurityUpdateApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/stgsec', requestBody, idToken);
        return result;
    }
    /**
     * 連絡先設定取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getContactApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/stgctt', requestBody, idToken);
        return result;
    }
    /**
     * 連絡先設定更新API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getContactUpdateApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/stgctt', requestBody, idToken);
        return result;
    }
    /**
     * 企業パスワード設定取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getPasswordApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/stgpwd', requestBody, idToken);
        return result;
    }
    /**
     * 企業パスワード設定更新API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getPasswordUpdateApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/stgpwd', requestBody, idToken);
        return result;
    }
    /**
     * 再委託先情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getRecommitmentApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/stgsub', requestBody, idToken);
        return result;
    }
    /**
     * ログ情報取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getLogApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/stglog', requestBody, idToken);
        return result;
    }
}
